export const checkIfMural = sku => {
  return (
    sku.endsWith('M') ||
    sku.endsWith('ML') ||
    sku.endsWith('MSA') ||
    sku.endsWith('MS')
  );
};
